import { Stack, Typography, Paper } from "@mui/material";

const MultiSegmentBar = ({ dataSegments, selectedType }: any) => {
  return (
    <Stack direction="row" gap={2} flexWrap="wrap">
      {dataSegments?.map((segment: any, index: number) => (
        <Paper
          key={index}
          variant="outlined"
          sx={{
            borderRadius: "8px",
            borderColor: segment.label.toLowerCase().includes("investigation")
              ? "error.main"
              : "divider",
            borderWidth: "1px",
            borderStyle: "solid",
            padding: "8px",
            minWidth: 220,
            gap: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
          }}
        >
          {/* Label */}
          <Typography
            sx={{
              fontSize: "16px",
              color: "text.secondary",
              mb: 0.5,
              fontWeight: 400,
            }}
          >
            {segment.label}
          </Typography>

          {/* Count + % + text */}
          <Stack direction="row" alignItems="baseline" spacing={1}>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 700,
                color: segment.label.toLowerCase().includes("investigation")
                  ? "error.main"
                  : "text.primary",
              }}
            >
              {segment.count}
            </Typography>
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 500,
                color: segment.label.toLowerCase().includes("investigation")
                  ? "error.main"
                  : "text.primary",
              }}
            >
              {segment.percent}%
            </Typography>
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 500,
              }}
            >
              Of Unloaded {selectedType}’s
            </Typography>
          </Stack>
        </Paper>
      ))}
    </Stack>
  );
};

export default MultiSegmentBar;
